import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import { useLingui } from '@lingui/react';
import './nav-links.scss';
import shuffleText from '../../../../utils/suffle-text'; // DATA

var HEADER_LINK_LIST = [{
  name:
  /*i18n*/
  i18n._("all projects"),
  slug: ''
}, {
  name:
  /*i18n*/
  i18n._("profile"),
  slug: 'profile'
}, {
  name:
  /*i18n*/
  i18n._("contact"),
  slug: 'contact'
}, {
  name:
  /*i18n*/
  i18n._("blog"),
  slug: 'blog'
}];
var SIDE_DRAWER_LINK_LIST = [{
  name:
  /*i18n*/
  i18n._("all projects"),
  slug: ''
}, {
  name:
  /*i18n*/
  i18n._("profile"),
  slug: 'profile'
}, {
  name:
  /*i18n*/
  i18n._("contact"),
  slug: 'contact'
}, {
  name:
  /*i18n*/
  i18n._("blog"),
  slug: 'blog'
}]; // const FOOTER_LINK_LIST = []

var NavLinks = function NavLinks(_ref) {
  var place = _ref.place;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  useEffect(function () {
    var n = HEADER_LINK_LIST.length;
    var ids = [];

    for (var i = 0; i < n; i++) {
      ids.push("header--" + i);
      ids.push("side-drawer--" + i);
    }

    ids.forEach(function (id) {
      shuffleText(id);
    });
  }, []);
  var navLinksJSX;

  switch (place) {
    case 'header':
      navLinksJSX = HEADER_LINK_LIST.map(function (_ref2, i) {
        var name = _ref2.name,
            slug = _ref2.slug;
        return /*#__PURE__*/React.createElement("li", {
          key: slug
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/" + locale + "/" + slug,
          id: "header--" + i
        }, i18n._(name)));
      });
      break;

    case 'side-drawer':
      navLinksJSX = SIDE_DRAWER_LINK_LIST.map(function (_ref3, i) {
        var name = _ref3.name,
            slug = _ref3.slug;
        return /*#__PURE__*/React.createElement("li", {
          key: slug
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/" + locale + "/" + slug,
          id: "side-drawer--" + i
        }, i18n._(name)));
      });
      break;

    case 'footer':
      // navLinksJSX = FOOTER_LINK_LIST.map(({ name, slug }) => (
      //   <li key={slug}>
      //     <Link
      //       to={`/${locale}/${slug}`}
      //       activeClassName="nav-links__link--active"
      //     >
      //       <Trans id={name} />
      //     </Link>
      //   </li>
      // ))
      break;

    default:
      navLinksJSX = null;
      break;
  }

  return /*#__PURE__*/React.createElement("ul", {
    className: "nav-links nav-links--" + place
  }, navLinksJSX);
};

export default NavLinks;